import {useStaticQuery, graphql} from 'gatsby'

export const getAllBlogs = graphql`
  query GetAllBlogs {
    allMdx(
      filter: {frontmatter: {templateKey: {eq: "blog-page"}}}
      sort: {order: DESC, fields: frontmatter___publish}
    ) {
      nodes {
        slug
        frontmatter {
          title
          image
          publish
          author
          blogTags
        }
      }
    }
  }
`

const useBlogQuery = () => {
  const {allMdx} = useStaticQuery(getAllBlogs)
  const articles = allMdx.nodes.map(item => ({
    slug: item.slug,
    ...item.frontmatter,
  }))

  return articles
}

export {useBlogQuery}
